import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { OMSDropdown } from "../../../app/common/common-components/OMSDropdown";
import { OMSMultiselectDropdown } from "../../../app/common/common-components/OMSMultiselectDropdown";
import { useStore } from "../../../app/stores/store";
import apiAgent from "../../../app/api/apiAgent";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";
import moment from "moment";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";
import { toast } from "react-toastify";

const TaskModel = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    onModelClick(stage, curTask) {
      console.log("Open Model");
      console.log(curTask);
      const roles = curTask.assignedRoles.map((curRole) => {
        return curRole.assignedRole;
      });
      setTaskModelData({
        taskId: curTask.taskId,
        dealId: curTask.dealId,
        dealName: curTask.dealName,
        taskName: curTask.taskName,
        stage: stage,
        prevstage: stage,
        statusUpdatedOn: curTask.statusUpdatedOn,
        stageExpected: curTask.stageExpected,
        taskCompletedDate: curTask.taskCompletedDate,
        status: curTask.status,
        description: curTask.description,
        taskDueDate: curTask.taskDueDate,
        comment: "",
        comments: curTask.comments,
        allAssignedRoles: [...curTask.assignedRoles],
        assignedRoles: [...roles],
        stageDD: curTask.stageDD,
        taskIndex: curTask.taskIndex,
        notified_persons: roles,
        notified_persons_selected: curTask.emailNotifiedRoles,
      });
      setFile(null);
      window.$(`#${props.modelId}`).modal("show");
    },
    onModelHide() {
      console.log("Close Model");
      window.$(`#${props.modelId}`).modal("hide");
    },
  }));

  const fileInputRef = useRef(null);

  const [taskModelData, setTaskModelData] = useState({
    taskId: "",
    dealId: "",
    dealName: "",
    taskName: "",
    stage: "",
    prevstage: "",
    status: 1,
    statusUpdatedOn: "",
    stageExpected: "",
    taskCompletedDate: "",
    description: "",
    comment: "",
    taskDueDate: "",
    comments: [],
    allAssignedRoles: [],
    assignedRoles: [],
    stageDD: [],
    taskIndex: "",
    notified_persons: [],
    notified_persons_selected: [],
  });
  const [editCommentIDX, setEditCommentIDX] = useState(null);
  const [file, setFile] = useState(null);
  const [buttonStatus, setButtonStatus] = useState({
    disabled: false,
    processing_save: false,
    processing_delete: false,
  });

  const {
    userStore: { userSession },
  } = useStore();

  // Model Open Handles
  const commentEditClick = (e, i) => {
    setTaskModelData({ ...taskModelData, comment: e.comment });
    setEditCommentIDX(i);
  };

  const onFileUploadClick = () => {
    fileInputRef.current.click();
  };

  // Task Model Data Handlers
  const taskModelDataChangeHandle = (name, e) => {
    if (name == "Task Name") {
      setTaskModelData({ ...taskModelData, taskName: e.target.value });
    } else if (name == "Desciption") {
      setTaskModelData({ ...taskModelData, description: e.target.value });
    } else if (name == "Comment") {
      setTaskModelData({ ...taskModelData, comment: e.target.value });
    } else if (name == "Stage") {
      setTaskModelData({ ...taskModelData, stage: e.newValue });
    } else if (name == "AssignedRoles") {
      setTaskModelData({ ...taskModelData, assignedRoles: e, notified_persons: e });
    } else if (name == "Date") {
      setTaskModelData({ ...taskModelData, taskDueDate: e.target.value });
    }
  };

  // Save Handles
  const onTaskSave = () => {
    if (taskModelData.taskName.trim().length == 0 || taskModelData.taskName == "" || !taskModelData.taskName) return toast.warn("TaskName is required");
    if (file != null) return toast.warn("There is a file in the comment section. You need to save the comment to save that file.");
    setButtonStatus({
      disabled: true,
      processing_save: true,
      processing_delete: false,
    });
    let curDate = displayDateAndTime();
    let rolesData = taskModelData.assignedRoles?.map((curEle) => {
      let agentName = [];
      props.contacts?.map((curContact) => {
        if (curContact.contactType == curEle) {
          agentName.push({ text: curContact.displayName, value: curContact.id });
        }
      });
      return { assignedRole: curEle, name: agentName };
    });
    let tags = taskModelData.notified_persons_selected.filter((curTag) => {
      return taskModelData.notified_persons.includes(curTag);
    });

    let task = {
      taskId: taskModelData.taskId,
      taskName: taskModelData.taskName,
      status: taskModelData.status,
      statusUpdatedOn: curDate,
      stageExpected: taskModelData.stageExpected,
      taskCompletedDate: taskModelData.taskCompletedDate,
      taskDueDate: taskModelData.taskDueDate,
      assignedRoles: rolesData,
      comments: taskModelData.comments,
      description: taskModelData.description,
      dealId: taskModelData.dealId,
      stageName: taskModelData.stage,
      stageDD: [],
      taskIndex: 0,
      emailNotifiedRoles: tags,
    };
    props.onSave(task, taskModelData.stage);
    window.$(`#${props.modelId}`).modal("hide");
    setTaskModelData({
      taskId: "",
      taskName: "",
      stage: "",
      prevstage: "",
      status: 1,
      statusUpdatedOn: "",
      stageExpected: "",
      description: "",
      comment: "",
      taskDueDate: "",
      comments: [],
      allAssignedRoles: [],
      assignedRoles: [],
      stageDD: [],
      taskIndex: 0,
      notified_persons: [],
      notified_persons_selected: [],
    });
    setButtonStatus({
      disabled: false,
      processing_save: false,
      processing_delete: false,
    });
  };

  const onCommentsAddClick = async () => {
    if (taskModelData.comment.trim().length == 0 || !taskModelData.comment) return toast.warn("Please enter a comment");
    setButtonStatus({
      disabled: true,
      processing_save: true,
      processing_delete: false,
    });
    const curDateAndTime = displayDateAndTime();
    let comments = [...taskModelData.comments];
    let eleComment;

    if (file) {
      const fileData = await fileUploadHandle();
      //console.log(fileData);
      eleComment = {
        commentID: "",
        userID: props.userID,
        comment: taskModelData.comment,
        isStatusChanged: false,
        createdOn: curDateAndTime,
        updatedOn: "",
        displayName: userSession?.displayName,
        fileID: fileData.fileID,
        fileName: fileData.fileName,
        documentName: fileData.documentName,
        url: "",
        size: fileData.size,
        displaySize: "",
      };
    } else {
      eleComment = {
        commentID: "",
        userID: props.userID,
        comment: taskModelData.comment,
        isStatusChanged: false,
        fileID: "",
        createdOn: curDateAndTime,
        updatedOn: "",
        displayName: userSession?.displayName,
        documentName: "",
        fileName: "",
        url: "",
        size: 0,
        displaySize: "",
      };
    }

    comments.push(eleComment);
    setTaskModelData({ ...taskModelData, comments: comments, comment: "" });
    setFile(null);
    setButtonStatus({
      disabled: false,
      processing_save: false,
      processing_delete: false,
    });
  };

  // Edit Handles
  const onTaskEditSave = (isTaskDelete) => {
    if (isTaskDelete) {
      let task = {
        taskId: taskModelData.taskId,
        dealId: taskModelData.dealId,
        taskName: taskModelData.taskName,
        status: taskModelData.status,
        assignedRoles: taskModelData.assignedRoles,
        description: taskModelData.description,
        comments: taskModelData.comments,
        statusUpdatedOn: taskModelData.statusUpdatedOn,
        stageExpected: taskModelData.stageExpected,
        stageName: taskModelData.stage,
        stageDD: taskModelData.stageDD,
        emailNotifiedRoles: taskModelData.notified_persons_selected,
      };

      props.onEdit(true, task, taskModelData.stage, taskModelData.prevstage);
    } else {
      if (taskModelData.taskName.trim().length == 0 || taskModelData.taskName == "" || !taskModelData.taskName) return toast.warn("TaskName is required");
      if (file != null) return toast.warn("There is a file in the comment section. You need to save the comment to save that file.");
      let curDate = displayDateAndTime();
      let rolesData = taskModelData.assignedRoles?.map((curEle) => {
        let agentName = [];
        props.contacts?.map((curContact) => {
          if (curContact.contactType == curEle) {
            agentName.push({ text: curContact.displayName, value: curContact.id });
          }
        });
        return { assignedRole: curEle, name: agentName };
      });
      let tags = taskModelData.notified_persons_selected.filter((curTag) => {
        return taskModelData.notified_persons.includes(curTag);
      });
      let task = {
        taskId: taskModelData.taskId,
        dealId: taskModelData.dealId,
        taskName: taskModelData.taskName,
        status: taskModelData.status,
        assignedRoles: rolesData,
        description: taskModelData.description,
        taskDueDate: taskModelData.taskDueDate,
        comments: taskModelData.comments,
        statusUpdatedOn: curDate,
        stageExpected: taskModelData.stageExpected,
        stageName: taskModelData.stage,
        stageDD: taskModelData.stageDD,
        emailNotifiedRoles: tags,
      };

      props.onEdit(false, task, taskModelData.stage, taskModelData.prevstage);
      window.$(`#${props.modelId}`).modal("hide");
      setTaskModelData({
        taskId: "",
        taskName: "",
        stage: "",
        prevstage: "",
        status: 1,
        statusUpdatedOn: "",
        stageExpected: "",
        description: "",
        taskDueDate: "",
        comment: "",
        comments: [],
        allAssignedRoles: [],
        assignedRoles: [],
        stageDD: [],
        taskIndex: 0,
        notified_persons: [],
        notified_persons_selected: [],
      });
    }
  };

  const onCommetEditSave = () => {
    if (taskModelData.comment.trim().length == 0 || !taskModelData.comment) return toast.warn("Please enter a comment.");
    let curDateAndTime = displayDateAndTime();
    let curComment = taskModelData.comments.find((ele, i) => {
      return i == editCommentIDX;
    });
    let eleComment = {
      commentID: curComment.commentID,
      userID: curComment.userID,
      comment: taskModelData.comment,
      isStatusChanged: curComment.isStatusChanged,
      fileID: curComment.fileID,
      createdOn: curComment.createdOn,
      updatedOn: curDateAndTime,
      displayName: curComment?.displayName,
      documentName: curComment.documentName,
      fileName: curComment.fileName,
      size: curComment.size,
      displaySize: curComment.displaySize,
      url: curComment.url,
    };
    let newComments = taskModelData.comments.filter((ele, i) => {
      return i != editCommentIDX;
    });

    newComments.splice(editCommentIDX, 0, eleComment);
    setTaskModelData({ ...taskModelData, comments: newComments, comment: "" });
    setEditCommentIDX(null);
  };

  // Task Status DD Handle
  const handleStatusDD = (e) => {
    if (e.newValue == 5) {
      onTaskEditSave(true);
    } else {
      setTaskModelData({ ...taskModelData, status: parseInt(e.newValue) });
      const curDateAndTime = displayDateAndTime();
      let commentSmg = "";
      let commentSmgValue = getTaskMIlestoneDD().find((curStatus) => {
        return curStatus.value == e.newValue;
      });
      if (commentSmgValue?.value == 1) {
        commentSmg = "marked this task as Not Started";
      } else if (commentSmgValue?.value == 2) {
        commentSmg = "marked this task as In Progress";
      } else if (commentSmgValue?.value == 3) {
        commentSmg = "marked this task as Issue";
      } else if (commentSmgValue?.value == 4) {
        commentSmg = "marked this task as Completed";
      } else if (commentSmgValue?.value == 5) {
        commentSmg = "marked this task as Deleted";
      }
      let eleComment = {
        commentID: "",
        userID: props?.userID,
        comment: `${userSession?.displayName} ${commentSmg}`,
        isStatusChanged: true,
        fileID: "",
        createdOn: curDateAndTime,
        updatedOn: "",
        displayName: userSession?.displayName,
        documentName: "",
        url: "",
      };
      taskModelData.comments.push(eleComment);
    }
  };

  // File Upload Handles
  const fileChangeHandle = (e) => {
    setFile(e.target.files[0]);
    e.target.value = "";
  };

  const fileUploadHandle = async () => {
    let fileData;
    var data = new FormData();
    data.append("file", file);
    await apiAgent.Deal.saveDealDocumentAjax(props.syncId, data).then((res) => {
      fileData = res;
      console.log("Inside saveDealDocumentAjax");
      console.log(fileData);
    });
    setFile(null);
    console.log("Outside saveDealDocumentAjax");
    console.log(fileData);
    return { ...fileData, size: file.size };
  };

  const onDownloadFile = (fileName) => {
    apiAgent.Deal.downloadDealDocumentAjax(fileName, props.syncId)
      .then((response) => {
        //console.log(response);
        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        // const disposition = response.headers["content-disposition"];
        // const parts = disposition.split(";");
        // const filenamePart = parts.find((part) => part.trim().startsWith("filename="));
        // const filenameWithExtension = filenamePart.split("=")[1].trim();
        // const extensionIndex = filenameWithExtension.lastIndexOf(".");
        // a.download = filenameWithExtension.substring(0, extensionIndex);
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error) => {
        console.error("Failed to download file:", error);
      });
  };
  // Remove Handles
  const onCommetRemove = (e, i) => {
    let comments = taskModelData.comments.filter((curCom, curIdx) => {
      return i != curIdx;
    });
    setTaskModelData({ ...taskModelData, comments: comments });
  };

  // Other Functions
  const displayDateAndTime = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const now = new Date();

    const day = now.getDate();
    const month = months[now.getMonth()];
    const year = now.getFullYear();

    let hours = now.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDateAndTime = `${day} ${month} ${year} at ${hours}:${minutes} ${ampm}`;

    return formattedDateAndTime;
  };
  const getTaskMIlestoneDD = (value) => {
    return [
      {
        text: "Not Started",
        value: 1,
      },
      {
        text: value == 2 ? "In Progress" : "Mark As In Progress",
        value: 2,
      },
      {
        text: value == 3 ? "Issue" : "Mark As Issue",
        value: 3,
      },
      {
        text: value == 4 ? "Completed" : "Mark As Completed",
        value: 4,
      },
      {
        text: "Delete Task",
        value: 5,
      },
    ];
  };

  const OnDealBreadcrumbClick = (e) => {
    console.log("OnDealBreadcrumbClick");
    window.$(`#${props.modelId}`).modal("hide");
  };

  const onTaskModelHide = (e) => {
    console.log("Close Model");
    window.$(`#${props.modelId}`).modal("hide");
  };
  const emailTagHandler = (e) => {
    if (e.target.checked) {
      setTaskModelData({ ...taskModelData, notified_persons_selected: [...taskModelData.notified_persons_selected, e.target.value] });
    } else {
      let tags = taskModelData.notified_persons_selected.filter((tag) => {
        return tag != e.target.value;
      });
      setTaskModelData({ ...taskModelData, notified_persons_selected: tags });
    }
  };

  return (
    <div className="modal fade" id={`${props.modelId}`} tabIndex={-1} role="dialog" aria-labelledby={`${props.modelId}`}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 className="modal-title text-center" id="">
              Save Task
            </h4>
          </div>
          <div className="modal-body">
            {props.isBreadCrumb === true && (
              <Breadcrumb
                breadcrumbs={[
                  {
                    text: taskModelData.dealName,
                    onClick: OnDealBreadcrumbClick,
                    path: `/Deal/saveDeal?ID=${taskModelData?.dealId}`,
                    style: { color: "black", fontWeight: "bold" },
                  },
                  { text: taskModelData.taskName, style: { borderBottom: "1px solid black", color: "black", fontWeight: "bold", cursor: "pointer" } },
                ]}
              />
            )}
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Task Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={taskModelData.taskName}
                    onChange={(e) => taskModelDataChangeHandle("Task Name", e)}
                    disabled={props.accessType == 1 ? false : true}
                  />
                </div>
                <div className="task_inp_container justify-content-between">
                  <div className="form-group" style={{ minWidth: "48%" }}>
                    <label>Stage</label>
                    <OMSDropdown
                      id={"stage"}
                      options={props.tasksStageDD}
                      valueField="value"
                      labelField="text"
                      value={taskModelData.stage}
                      onChange={(e) => taskModelDataChangeHandle("Stage", e)}
                      disabled={props.accessType == 1 ? false : true}
                    />
                  </div>
                  <div className={`form-group bg${taskModelData.status}status`} style={{ minWidth: "48%" }}>
                    <label>Status</label>
                    <OMSDropdown
                      id={"status"}
                      options={getTaskMIlestoneDD(taskModelData.status)}
                      valueField="value"
                      labelField="text"
                      value={taskModelData.status}
                      onChange={(e) => handleStatusDD(e)}
                      disabled={props.accessType == 1 ? false : true}
                    />
                  </div>
                </div>
                <div className="task_inp_container justify-content-between">
                  <div className="form-group" style={{ minWidth: "48%" }}>
                    <label>Assigned Roles</label>
                    {props.accessType == 1 ? (
                      <OMSMultiselectDropdown
                        id="roles"
                        name="Choose some options..."
                        options={props.assignedRolesDD}
                        valueField="value"
                        labelField="text"
                        value={taskModelData.assignedRoles}
                        onChange={(e) => taskModelDataChangeHandle("AssignedRoles", e)}
                      />
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        value={taskModelData.assignedRoles.map((curEle, i) => {
                          if (i == 0) {
                            return `${curEle}`;
                          }
                          return `, ${curEle}`;
                        })}
                        disabled
                      />
                    )}
                  </div>
                  <div className="form-group" style={{ minWidth: "48%" }}>
                    <label>Due Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={taskModelData.taskDueDate}
                      onChange={(e) => taskModelDataChangeHandle("Date", e)}
                      disabled={props.accessType == 1 ? false : true}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    class="form-control"
                    rows="2"
                    value={taskModelData.description}
                    onChange={(e) => taskModelDataChangeHandle("Desciption", e)}
                    disabled={props.accessType == 1 ? false : true}
                  ></textarea>
                </div>
                <div className="form-group commetns_area">
                  <label>Comments</label>
                  <textarea class="form-control" rows="3" value={taskModelData.comment} onChange={(e) => taskModelDataChangeHandle("Comment", e)}></textarea>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png,.txt,.pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                    style={{ display: "none" }}
                    onChange={(e) => fileChangeHandle(e)}
                    multiple={false}
                    ref={fileInputRef}
                  />
                  {file == null ? null : (
                    <p className="tag2 bg-oms" style={{ width: "auto" }}>
                      {file.name}
                    </p>
                  )}
                  {editCommentIDX == null ? (
                    <span>
                      <i className="fa  fa-paperclip" style={{ fontSize: "22px" }} onClick={() => onFileUploadClick()}></i>
                      <i className="fa fa-paper-plane-o" onClick={() => onCommentsAddClick()}></i>
                    </span>
                  ) : (
                    <span>
                      <i className="fa  fa-paperclip" style={{ fontSize: "22px" }} onClick={() => onFileUploadClick()}></i>
                      <i className="fa fa-paper-plane-o" onClick={() => onCommetEditSave()}></i>
                    </span>
                  )}
                </div>
                {props.isTaskEdit && (
                  <div className="comment_box mt-2">
                    <ul>
                      {taskModelData?.comments?.map((curComent, i) => {
                        if (curComent.isStatusChanged === false) {
                          return (
                            <li key={i} className="comment_item align-items-end">
                              <div className="com_info">
                                <span>
                                  <b>{userSession?.displayName} </b> {curComent.createdOn}
                                </span>
                              </div>
                              <div className="com_data bgcomment">
                                <span>{curComent.comment}</span>
                                {curComent.documentName && (
                                  <div className="mt-1">
                                    <span
                                      className="tag2 bg-oms"
                                      title="open/download file"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => onDownloadFile(curComent.fileName)}
                                    >
                                      {curComent.documentName}
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div className="com_actions">
                                <a className="model_link mx-1" onClick={() => commentEditClick(curComent, i)}>
                                  Edit
                                </a>
                                <a className="model_link" onClick={() => onCommetRemove(curComent, i)}>
                                  Delete
                                </a>
                              </div>
                            </li>
                          );
                        } else if (curComent.isStatusChanged === true) {
                          return (
                            <li key={i} className="comment_item align-items-start">
                              <div className="com_info">
                                <span>
                                  <b>{userSession?.displayName} </b> {curComent.createdOn}
                                </span>
                              </div>
                              <div className="com_data bgstatus">
                                <span>{curComent.comment}</span>
                              </div>
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>
                )}
                {props.superAdmin && (
                  <div className="form-group">
                    <label>email notifications on new comment</label>
                    <div className="d-flex flex-wrap">
                      {taskModelData.notified_persons?.map((curTag) => {
                        return (
                          <div className="d-flex align-items-center mb-1 mr-1">
                            <input
                              type="checkbox"
                              className="my-0 mr-1"
                              value={curTag}
                              checked={taskModelData.notified_persons_selected.includes(curTag)}
                              onChange={(e) => emailTagHandler(e)}
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className={`task_email_tag`} style={{ background: props.getRoleBg(curTag) || "#4d4d4d" }}>
                              {curTag}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <div className="col-md-12">
              <button type="button" className="btn btn-default" onClick={() => onTaskModelHide()}>
                <i className="fa fa-times"></i> Cancel
              </button>
              {props.isTaskEdit ? (
                <OMSButtonStyleL
                  style={{ marginRight: 10 }}
                  type="button"
                  ui_icon="fa-check"
                  ui_type="save"
                  ui_text="Save"
                  ui_processing_text="Saving.."
                  processing={buttonStatus.processing_save}
                  disabled={buttonStatus.disabled}
                  onClick={() => onTaskEditSave(false)}
                />
              ) : (
                <OMSButtonStyleL
                  type="button"
                  ui_icon="fa-check"
                  ui_type="save"
                  ui_text="Save"
                  ui_processing_text="Saving.."
                  processing={buttonStatus.processing_save}
                  disabled={buttonStatus.disabled}
                  onClick={() => onTaskSave()}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default TaskModel;
